import axios from 'axios'

/**
 * 获取OSS签名URL用于文件直传（管理员专用）
 * @param {FormData} formData - 包含 filename 和 file_type 的表单数据
 * @returns {Promise} 返回包含 presigned_url, oss_file_path, file_url 的响应
 */
export function getOssUploadUrl(formData) {
  const token = localStorage.getItem('token')
  return axios({
    url: '/api/upload/get-oss-upload-url',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': token ? `Bearer ${token}` : ''
    }
  })
}

/**
 * 获取OSS签名URL用于文件直传（普通用户可用）
 * @param {FormData} formData - 包含 filename 和 file_type 的表单数据
 * @returns {Promise} 返回包含 presigned_url, oss_file_path, file_url 的响应
 */
export function getOssUrl(formData) {
  const token = localStorage.getItem('token')
  return axios({
    url: '/api/upload/get-oss-url',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': token ? `Bearer ${token}` : ''
    }
  })
}



